import 'angular';
import '../services/organization.service';
import '../../../components/cloudinary_image/cloudinary_image.component';
import template from './report_shortlisted.template.html?raw';

const moduleDependencies = ['fundingSearchApp.services.Organization', 'components.cloudinaryImage'];

angular
  .module('fundingSearchApp.directives.reportShortlisted', moduleDependencies)
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(template, template);
  }])
  .directive('reportShortlisted', [
    'Organization',
    Organization => {
      const link = $scope => {
        $scope.consortiumHasCompanies = consortium => {
          const filteredCompanies = consortium.consortium_companies.filter(item => {
            return item.company_name || item.company && item.company.name;
          }).length;

          return Boolean(filteredCompanies);
        };

        $scope.showOrganizationLink = Organization.showOrganizationLink;
      };

      return {
        restrict: 'E',
        templateUrl: template,
        link,
        scope: {
          organizations: '=',
          consortiums: '='
        }
      };
    }
  ]);
